var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCloseIcon2 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "12px",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Wireframes-2.0",
    stroke: "currentColor",
    strokeWidth: 1,
    fill: "currentColor",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "2.6.1-Onboarding---Departments---Define-New-Department",
    transform: "translate(-954.000000, -396.000000)",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M965.597152,396.40276 C965.081902,395.88778 964.246684,395.88778 963.731434,396.40276 L960,400.134693 L956.268566,396.40276 C955.937283,396.059833 955.446703,395.922301 954.985381,396.043026 C954.524058,396.16375 954.163786,396.523943 954.043035,396.985164 C953.922284,397.446385 954.059846,397.936857 954.402848,398.268067 L958.134283,402 L954.402848,405.731933 C954.059846,406.063143 953.922284,406.553615 954.043035,407.014836 C954.163786,407.476057 954.524058,407.83625 954.985381,407.956974 C955.446703,408.077699 955.937283,407.940167 956.268566,407.59724 L960,403.865307 L963.731434,407.59724 C964.062717,407.940167 964.553297,408.077699 965.014619,407.956974 C965.475942,407.83625 965.836214,407.476057 965.956965,407.014836 C966.077716,406.553615 965.940154,406.063143 965.597152,405.731933 L961.865717,402 L965.597152,398.268067 C966.112245,397.752931 966.112245,396.917896 965.597152,396.40276 Z",
    id: "Path"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCloseIcon2);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/closeIcon2.a0c28d5963a7dde060cc53a7b730d29b.svg";